import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import remindersSAService from "services/superadmin/remindersSAService";
import AppSmartForm from "components/AppSmartForm/AppSmartForm";

const ReminderForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { reminder },
}) => {

  const fieldsWithData = [
    {
      key: "name",
      label: "Зоголовок",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "text",
      label: "Текст",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "link",
      label: "Ссылка",
      inputType: inputTypeEnum.text,
    },
    // Time
    {
      key: "time",
      label: "Время",
      inputType: inputTypeEnum.time,
    },
    // Week days
    {
      key: "weekDays",
      label: "Дни недели",
      inputType: inputTypeEnum.autocomplete,
      multiple: true,
      value: [],
      options: [
        {
          id: "monday",
          name: "Понедельник"
        },
        {
          id: "tuesday",
          name: "Вторник"
        },
        {
          id: "wednesday",
          name: "Среда"
        },
        {
          id: "thursday",
          name: "Четверг"
        },
        {
          id: "friday",
          name: "Пятница"
        },
        {
          id: "saturday",
          name: "Суббота"
        },
        {
          id: "sunday",
          name: "Воскресенье"
        }
      ],
    },
    {
      key: "translations",
      label: "Переводы",
      inputType: inputTypeEnum.array,
      fields: [
        {
          key: "name",
          label: "Название",
          inputType: inputTypeEnum.text,
        },
        {
          key: "text",
          label: "Текст",
          inputType: inputTypeEnum.text,
        }
      ]
    }
  ]

  const onSubmit = async (formValues) => {
    try {
      if (reminder) {
        await remindersSAService.put(id, formValues)
        snack("Напоминание обновлено успешно!");
      } else {
        await remindersSAService.post(formValues)
        snack("Напоминание создано успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={reminder ? 'Создание напоминании' : 'Создание напоминании'}>
      <AppSmartForm onSubmit={onSubmit} data={reminder} fields={fieldsWithData}></AppSmartForm>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(ReminderForm, (router) => {
    let requests = {}
    if (router.params.id) {
      requests['reminder'] = () => remindersSAService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
